import * as React from "react";
const UserManagementIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M5.665 11.501a3.61 3.61 0 1 0 0-7.22 3.61 3.61 0 0 0 0 7.22Zm0-5.7a2.091 2.091 0 1 1 0 4.184 2.091 2.091 0 0 1 0-4.185v.001ZM1.52 16.814a2.816 2.816 0 0 1 2.813-2.813h2.659c.08 0 .158 0 .236.01a.787.787 0 0 0 .6-.2.743.743 0 0 0 .242-.552.76.76 0 0 0-.675-.756 4.089 4.089 0 0 0-.4-.019H4.336A4.336 4.336 0 0 0 0 16.814v.312h1.52v-.312ZM8.338 17.125h1.519v-1.87a3.183 3.183 0 0 1 3.18-3.18h2.93a3.183 3.183 0 0 1 3.18 3.18v1.87h1.52v-1.87a4.709 4.709 0 0 0-4.7-4.7h-2.931a4.713 4.713 0 0 0-4.7 4.7v1.87h.002ZM24.673 12.484h-2.66c-.073 0-.147 0-.221.006a.762.762 0 0 0-.492 1.314.748.748 0 0 0 .56.2H24.674a2.816 2.816 0 0 1 2.813 2.813v.312h1.519v-.312a4.337 4.337 0 0 0-4.332-4.332h-.001ZM23.348 11.501a3.61 3.61 0 1 0 0-7.22 3.61 3.61 0 0 0 0 7.22Zm0-5.7a2.09 2.09 0 1 1 0 4.184 2.09 2.09 0 0 1 0-4.185v.001ZM14.502 9.957a4.541 4.541 0 1 0 0-9.082 4.541 4.541 0 0 0 0 9.082Zm0-7.563a3.022 3.022 0 1 1-3.022 3.022 3.026 3.026 0 0 1 3.022-3.02v-.002Z"
    />
  </svg>
);
export default UserManagementIcon;
